/*
 * @providesModule PaymentDataUtils
 * Generic utilities for ServerPaymentsResponse
 */

import {ServerPaymentsResponse} from 'StoreInfo';

export const isNewPayingUser = (paymentData: ServerPaymentsResponse): boolean => {
  if (!paymentData) {
    return false;
  }

  const {aeropay, apple_pay, paypal, stored_cards} = paymentData;

  const hasDepositedWithPayPal = !!paypal?.payment_token_id && !!paypal?.email;
  const hasDepositedWithApplePay = !!apple_pay?.three_ds_enabled && !!apple_pay?.stored;
  const hasDepositedWithBankAccount = !!aeropay?.user_has_deposited;
  // we currently don't track if a user has deposited without saving the card
  const hasSavedCreditCard = !!stored_cards?.length;

  const isNewPayingUser =
    [
      hasDepositedWithPayPal,
      hasDepositedWithApplePay,
      hasDepositedWithBankAccount,
      hasSavedCreditCard,
    ].filter(Boolean).length === 1;

  return isNewPayingUser;
};
